import { tzAxios } from 'api/axios';
import { ProfileEditRequest } from 'api/requestTypes';
import { ProfileDetailsResponse } from 'api/responseTypes';
import { withAuthHeader } from 'api/utils/authenticatedRequest';

export const getProfileInfo = async (token: string) =>
  (await tzAxios.get<ProfileDetailsResponse>('/users/me', withAuthHeader(token))).data;

export const putProfileInfo = async (payload: ProfileEditRequest) => {
  const parsedPayload: ProfileEditRequest = {
    name: payload.name,
    email: payload.email || null,
  };
  return (await tzAxios.patch<ProfileEditRequest>(`/users/me`, parsedPayload)).data;
};
